module.exports = __webpack_public_path__ + "img/icon-dingyue.116497ff.png";